import { render, staticRenderFns } from "./JSONDialog.vue?vue&type=template&id=8e9265d4&scoped=true"
import script from "./JSONDialog.vue?vue&type=script&lang=js"
export * from "./JSONDialog.vue?vue&type=script&lang=js"
import style0 from "./JSONDialog.vue?vue&type=style&index=0&id=8e9265d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9265d4",
  null
  
)

export default component.exports